import SettingsContent from '../Wrapper.vue';
import Index from './Index.vue';
import EmailTemplateEditor from './EmailTemplateEditor.vue';
import EmailTemplateView from './EmailTemplateView.vue';
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/email_templates'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'email_templates_wrapper';
        return {
          headerTitle: 'EMAIL_TEMPLATES.HEADER',
          headerButtonText: 'EMAIL_TEMPLATES.HEADER_BTN_TXT',
          icon: 'mail',
          showBackButton,
          keepAlive: false,
        };
      },
      children: [
        {
          path: '',
          name: 'email_templates_wrapper',
          component: Index,
          roles: ['administrator', 'agent'],
        },
        {
          path: 'new',
          name: 'email_templates_new',
          component: EmailTemplateEditor,
          roles: ['administrator', 'agent'],
        },
        {
          path: ':templateId/view',
          name: 'email_templates_view',
          component: EmailTemplateView,
          roles: ['administrator', 'agent'],
        },
        {
          path: ':templateId/edit',
          name: 'email_templates_edit',
          component: EmailTemplateEditor,
          roles: ['administrator', 'agent'],
        },
      ],
    },
  ],
};
